export const API_URL = process.env.REACT_APP_API_URL || "https://below2000-api.onrender.com";
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "142013333965-rvn982paejcqktaqp3kb9b4jqvacb7c0.apps.googleusercontent.com";

export default API_URL;
